import { Point } from "tm-shared/types";

import { PageBlock } from "@/shared/pageComposition/BlockList";

import { AboutPointCapabilities } from "./AboutPoint.policy";
import { AddressAlertBlock } from "./blocks/AddressAlertBlock";
import { HeaderBlock } from "./blocks/HeaderBlock";
import { TabsBlock } from "./blocks/TabsBlock";

export type AboutPointModel = {
    capabilities: AboutPointCapabilities;
    point: Point;
};

export const getAboutPointBlocks = (
    model: AboutPointModel,
): PageBlock<AboutPointModel>[] => [
    {
        key: "header",
        order: 10,
        render: () => <HeaderBlock point={model.point} />,
    },
    {
        key: "address-alert",
        order: 20,
        isVisible: (model) =>
            model.capabilities.canSeeAddressVerifyAlert &&
            !model.point.market.building.address?.id,
        render: () => (
            <AddressAlertBlock
                marketId={model.point.market.id}
                pointId={model.point.id}
            />
        ),
    },
    {
        key: "tabs",
        order: 30,
        render: () => (
            <TabsBlock capabilities={model.capabilities} point={model.point} />
        ),
    },
];
